module.exports = __webpack_public_path__ + "media/icons/user-group-b4f2e9e2.svg";